import { Admin } from 'components/base/Admin'
import { Fragment } from 'react'
import { TopExtend } from './extend'
import { FV } from './fv'
import { PCHeader } from 'components/common/header/pc'

export function TopViewPc() {
  return (
    <Fragment>
      <PCHeader isTopPage />
      <div className='fixed d-left-[16px] d-bottom-[16px] z-50'>
        <Admin />
      </div>
      <FV />
      <TopExtend />
    </Fragment>
  )
}
